"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _TypeString = _interopRequireDefault(require("./TypeString"));
var _TypeDate = _interopRequireDefault(require("./TypeDate"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/OutputTable/Search/InputType.js";
function InputType(_ref) {
  var type = _ref.type,
    field = _ref.field,
    onChange = _ref.onChange;
  switch (type) {
    case 'String':
      return /*#__PURE__*/React.createElement(_TypeString["default"], {
        field: field,
        onChange: onChange,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 7,
          columnNumber: 20
        }
      });
    case 'Date':
      return /*#__PURE__*/React.createElement(_TypeDate["default"], {
        field: field,
        onChange: onChange,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 11,
          columnNumber: 20
        }
      });
    default:
      return null;
  }
}
var _default = InputType;
exports["default"] = _default;